﻿(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _scrollAnimation = _interopRequireDefault(require("./components/scrollAnimation.js"));
var _headerToggle = _interopRequireDefault(require("./components/headerToggle.js"));
var _aboutMv = _interopRequireDefault(require("./components/aboutMv.js"));
var _historySlide = _interopRequireDefault(require("./components/historySlide.js"));
var _qualitySlide = _interopRequireDefault(require("./components/qualitySlide.js"));
var _topMvSlide = _interopRequireDefault(require("./components/topMvSlide.js"));
var _topProductsSlide = _interopRequireDefault(require("./components/topProductsSlide.js"));
var _topBrandsSlide = _interopRequireDefault(require("./components/topBrandsSlide.js"));
var _recruitRequirement = _interopRequireDefault(require("./components/recruitRequirement.js"));
var _topHeader = _interopRequireDefault(require("./components/topHeader.js"));
var _scrollHeader = _interopRequireDefault(require("./components/scrollHeader.js"));
var _shopList = _interopRequireDefault(require("./components/shopList.js"));
var _customerSlide = _interopRequireDefault(require("./components/customerSlide.js"));
var _customerDisclaimer = _interopRequireDefault(require("./components/customerDisclaimer.js"));
var _customerQuality = _interopRequireDefault(require("./components/customerQuality.js"));
var _customerFAQ = _interopRequireDefault(require("./components/customerFAQ.js"));
var _anchorLink = _interopRequireDefault(require("./components/anchorLink.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
gsap.registerPlugin(ScrollTrigger);
var anchorLink = new _anchorLink["default"]();
var scrollAnimation = new _scrollAnimation["default"]();
var headerToggle = new _headerToggle["default"]();
var aboutMv = new _aboutMv["default"]();
var historySlide = new _historySlide["default"]();
var qualitySlide = new _qualitySlide["default"]();
var topMvSlide = new _topMvSlide["default"]();
var topProductsSlide = new _topProductsSlide["default"]();
var topBrandsSlide = new _topBrandsSlide["default"]();
var recruitRequirement = new _recruitRequirement["default"]();
var topHeader = new _topHeader["default"]();
var scrollHeader = new _scrollHeader["default"]();
var shopList = new _shopList["default"]();
var customerSlide = new _customerSlide["default"]();
var customerDisclaimer = new _customerDisclaimer["default"]();
var customerQuality = new _customerQuality["default"]();
var customerFAQ = new _customerFAQ["default"]();

},{"./components/aboutMv.js":2,"./components/anchorLink.js":3,"./components/customerDisclaimer.js":4,"./components/customerFAQ.js":5,"./components/customerQuality.js":6,"./components/customerSlide.js":7,"./components/headerToggle.js":8,"./components/historySlide.js":9,"./components/qualitySlide.js":10,"./components/recruitRequirement.js":11,"./components/scrollAnimation.js":12,"./components/scrollHeader.js":13,"./components/shopList.js":14,"./components/topBrandsSlide.js":15,"./components/topHeader.js":16,"./components/topMvSlide.js":17,"./components/topProductsSlide.js":18}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var aboutMv = exports["default"] = /*#__PURE__*/function () {
  function aboutMv() {
    _classCallCheck(this, aboutMv);
    if (!document.querySelector('.mv')) return;
    this.mvScroll();
  }
  return _createClass(aboutMv, [{
    key: "mvScroll",
    value: function mvScroll() {
      var mv = document.querySelector('.mv');
      var isMobile = window.matchMedia('screen and (max-width: 768px)').matches;
      gsap.fromTo(mv, {
        '--blur-opacity': isMobile ? '0' : '0'
      }, {
        '--blur-opacity': isMobile ? '1' : '1',
        scrollTrigger: {
          trigger: '.mv__concept',
          start: 'top center',
          end: '+=200',
          scrub: 1,
          markers: false,
          invalidateOnRefresh: true
        }
      });
    }
  }]);
}();

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AnchorLink = exports["default"] = /*#__PURE__*/function () {
  function AnchorLink() {
    _classCallCheck(this, AnchorLink);
    this.init();
  }
  return _createClass(AnchorLink, [{
    key: "init",
    value: function init() {
      var _this = this;
      var linkEl = document.querySelectorAll('a[href^="#"]');
      if (!linkEl) return;
      var linkElArray = Array.prototype.slice.call(linkEl, 0);
      linkElArray.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var targetID = link.getAttribute('href').slice(1);
          var targetEl = document.getElementById(targetID);
          var buffer = 0;
          if (link.classList.contains('js-article-detail-index')) {
            buffer = 100;
          }
          _this.smoothScrollToTargetPosition(e, link, buffer);
          return false;
        });
      });
    }

    /**
     * アニメーションつきスクロール
     */
  }, {
    key: "smoothScrollToTargetPosition",
    value: function smoothScrollToTargetPosition(e) {
      var respond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var buffer = arguments.length > 2 ? arguments[2] : undefined;
      var distanceToTop = function distanceToTop(el) {
        return Math.floor(el.getBoundingClientRect().top - buffer);
      };
      e.preventDefault();
      var targetID = respond ? respond.getAttribute('href') : this.getAttribute('href');
      var targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      var originalTop = distanceToTop(targetAnchor);
      window.scrollBy({
        top: originalTop,
        left: 0,
        behavior: 'smooth'
      });
      console.log('Smooth Scroll / Buffer: ' + buffer);
    }
  }]);
}();

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RepairDisclaimer = exports["default"] = /*#__PURE__*/function () {
  function RepairDisclaimer() {
    _classCallCheck(this, RepairDisclaimer);
    if (!document.querySelector('.main-wrapper--customer .repair')) return;
    this.disclaimerInit();
  }
  return _createClass(RepairDisclaimer, [{
    key: "disclaimerInit",
    value: function disclaimerInit() {
      var button = document.querySelector('.repair__disclaimer-button');
      var disclaimerList = document.querySelector('.repair__disclaimer-list');
      button.addEventListener('click', function () {
        var smallHeight = 205;
        var originalHeight = disclaimerList.scrollHeight;
        disclaimerList.style.height = smallHeight + "px";
        disclaimerList.style.transition = "height 0.3s";
        disclaimerList.style.height = originalHeight + "px";
        disclaimerList.addEventListener("transitionend", function () {
          disclaimerList.style.height = "auto";
        }, {
          once: true
        });
        button.style.display = "none";
      });
    }
  }]);
}();

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RepairQuality = exports["default"] = /*#__PURE__*/function () {
  function RepairQuality() {
    _classCallCheck(this, RepairQuality);
    if (!document.querySelector('.main-wrapper--customer .repair')) return;
    this.toggleContents();
  }
  return _createClass(RepairQuality, [{
    key: "toggleContents",
    value: function toggleContents() {
      var requirementSections = document.querySelectorAll('.faq__section');
      var firstSection = requirementSections[0];
      var firstSectionContents = firstSection.querySelector('.faq__section-contents');
      var firstSectionContentsInner = firstSection.querySelector('.faq__section-contentsInner');
      var firstMaxHeight = firstSectionContentsInner ? getComputedStyle(firstSectionContentsInner).height : '0px';
      firstSectionContents.style.maxHeight = firstMaxHeight;
      firstSection.classList.add('is_open');
      requirementSections.forEach(function (section) {
        var sectionHeader = section.querySelector('.faq__section-header');
        var sectionHeaderButton = section.querySelector('.faq__section-headerButton');
        section.addEventListener('click', function (e) {
          if (section.classList.contains('is_open')) {
            return;
          }
          var sectionContents = section.querySelector('.faq__section-contents');
          var sectionContentsInner = section.querySelector('.faq__section-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.faq__section-contents').style.maxHeight) {
              otherSection.querySelector('.faq__section-contents').style.maxHeight = '';
              otherSection.querySelector('.faq__section-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
        sectionHeaderButton.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!section.classList.contains('is_open')) {
            e.preventDefault();
          }
          var sectionContents = section.querySelector('.faq__section-contents');
          var sectionContentsInner = section.querySelector('.faq__section-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.faq__section-contents').style.maxHeight) {
              otherSection.querySelector('.faq__section-contents').style.maxHeight = '';
              otherSection.querySelector('.faq__section-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
      });
    }
  }]);
}();

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RepairQuality = exports["default"] = /*#__PURE__*/function () {
  function RepairQuality() {
    _classCallCheck(this, RepairQuality);
    if (!document.querySelector('.main-wrapper--customer .repair')) return;
    this.toggleContents();
  }
  return _createClass(RepairQuality, [{
    key: "toggleContents",
    value: function toggleContents() {
      var requirementSections = document.querySelectorAll('.quality__brand');
      var firstSection = requirementSections[0];
      var firstSectionContents = firstSection.querySelector('.quality__brand-contents');
      var firstSectionContentsInner = firstSection.querySelector('.quality__brand-contentsInner');
      var firstMaxHeight = firstSectionContentsInner ? getComputedStyle(firstSectionContentsInner).height : '0px';
      firstSectionContents.style.maxHeight = firstMaxHeight;
      firstSection.classList.add('is_open');
      requirementSections.forEach(function (section) {
        var sectionHeader = section.querySelector('.quality__brand-header');
        var sectionHeaderButton = section.querySelector('.quality__brand-headerButton');
        section.addEventListener('click', function (e) {
          if (section.classList.contains('is_open')) {
            return;
          }
          var sectionContents = section.querySelector('.quality__brand-contents');
          var sectionContentsInner = section.querySelector('.quality__brand-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.quality__brand-contents').style.maxHeight) {
              otherSection.querySelector('.quality__brand-contents').style.maxHeight = '';
              otherSection.querySelector('.quality__brand-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
        sectionHeaderButton.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!section.classList.contains('is_open')) {
            e.preventDefault();
          }
          var sectionContents = section.querySelector('.quality__brand-contents');
          var sectionContentsInner = section.querySelector('.quality__brand-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.quality__brand-contents').style.maxHeight) {
              otherSection.querySelector('.quality__brand-contents').style.maxHeight = '';
              otherSection.querySelector('.quality__brand-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
      });
    }
  }]);
}();

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RepairSlide = exports["default"] = /*#__PURE__*/function () {
  function RepairSlide() {
    _classCallCheck(this, RepairSlide);
    if (!document.querySelector('.main-wrapper--customer .repair')) return;
    this.sliderInit();
  }
  return _createClass(RepairSlide, [{
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.repair__inner');
      boxes.forEach(function (box) {
        var splideElement = box.querySelector('.splide');
        var splide = new Splide(splideElement, {
          type: 'slide',
          drag: 'free',
          rewind: false,
          perPage: 1,
          perMove: 1,
          gap: 20,
          pagination: true,
          arrows: false,
          speed: 800,
          autoWidth: true,
          padding: {
            left: '20px',
            right: '20px'
          },
          snap: true,
          mediaQuery: 'min',
          breakpoints: {
            768: {
              perPage: 3,
              width: "100%",
              pagination: false,
              arrows: true,
              padding: {
                left: '90px',
                right: '90px'
              }
            }
          }
        });
        splide.mount();
      });
    }
  }]);
}();

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// var headerToggle = exports["default"] = /*#__PURE__*/function () {
//   function headerToggle() {
//     _classCallCheck(this, headerToggle);
//     if (!document.querySelector('.header')) return;
//     this.menuToggle();
//     this.subMenuToggle();
//   }
//   return _createClass(headerToggle, [{
//     key: "menuToggle",
//     value: function menuToggle() {
//       var header = document.querySelector(".header");
//       var menu = document.querySelector(".headerMenu");
//       var subMenu = document.querySelector(".headerMenu__box--sub");
//       var menuOpen = document.querySelector(".header__box-item--menu");
//       var bg = document.querySelector(".headerMenu__bg");
//       var torggleButton = document.querySelector(".headerMenu__item--toggle");
//       var fixed = function fixed(apply) {
//         var body = document.body;
//         if (apply) {
//           var scrollY = window.scrollY;
//           document.documentElement.style.setProperty('--scroll-y', "".concat(scrollY, "px"));
//           body.style.position = 'fixed';
//           body.style.top = "-".concat(scrollY, "px");
//         } else {
//           var _scrollY = parseInt(document.documentElement.style.getPropertyValue('--scroll-y') || '0');
//           body.style.position = '';
//           body.style.top = '';
//           window.scrollTo(0, _scrollY);
//         }
//       };
//       var toggleMenu = function toggleMenu(element, button) {
//         var isAlreadyOpen = element.classList.contains("is_open");
//         if (!isAlreadyOpen) {
//           closeAllMenus();
//           element.classList.add("is_open");
//           button.classList.add("is_open");
//           header.classList.add("is_open");
//           fixed(true);
//         } else {
//           header.classList.remove("is_open");
//           element.classList.remove("is_open");
//           button.classList.remove("is_open");
//           subMenu.classList.remove("is_open");
//           torggleButton?.classList.remove("is_open");
//           fixed(false);
//         }
//       };
//       var closeAllMenus = function closeAllMenus() {
//         if (menu.classList.contains("is_open")) {
//           fixed(false); // Ensure to remove fixed when any menu is open and being closed
//         }
//         menu.classList.remove("is_open");
//         menuOpen.classList.remove("is_open");
//         header.classList.remove("is_open");
//         subMenu.classList.remove("is_open");
//         torggleButton?.classList.remove("is_open");
//       };
//       menuOpen.addEventListener('click', function () {
//         return toggleMenu(menu, menuOpen);
//       });
//       bg.addEventListener('click', closeAllMenus);
//     }
//   }, {
//     key: "subMenuToggle",
//     value: function subMenuToggle() {
//       var button = document.querySelector(".headerMenu__item--toggle");
//       var subMenu = document.querySelector(".headerMenu__box--sub");
//       var backButton = document.querySelector(".headerMenu__back-item");
//       var toggleSubMenu = function toggleSubMenu() {
//         subMenu.classList.toggle("is_open");
//         button.classList.toggle("is_open"); // buttonにもis_openを追加
//       };
//       var closeSubMenu = function closeSubMenu() {
//         subMenu.classList.remove("is_open");
//         button.classList.remove("is_open"); // buttonのis_openも削除
//       };
//       button.addEventListener('click', toggleSubMenu);
//       backButton.addEventListener('click', closeSubMenu);
//     }
//   }]);
// }();
var headerToggle = exports["default"] = /*#__PURE__*/function () {
  function headerToggle() {
    _classCallCheck(this, headerToggle);
    if (!document.querySelector('.header')) return;
    this.menuToggle();
    this.subMenuToggle();
  }
  return _createClass(headerToggle, [{
    key: "menuToggle",
    value: function menuToggle() {
      var _this = this;
      var header = document.querySelector(".header");
      var menu = document.querySelector(".headerMenu");
      var subMenu = document.querySelector(".headerMenu__box--sub");
      var menuOpen = document.querySelector(".header__box-item--menu");
      var bg = document.querySelector(".headerMenu__bg");
      var torggleButton = document.querySelector(".headerMenu__item--toggle");

      // スクロール固定・解除関数（smoothスクロール干渉対策入り）
      var fixed = function fixed(apply) {
        var body = document.body;
        var html = document.documentElement;

        if (apply) {
          _this.currentScrollY = window.scrollY || window.pageYOffset;
          body.style.position = 'fixed';
          body.style.top = "-".concat(_this.currentScrollY, "px");
          body.style.width = '100%';
        } else {
          // スクロール復元時のみ一時的に smooth を解除して一瞬で戻す
          html.style.scrollBehavior = 'auto';

          var scrollY = _this.currentScrollY || 0;
          body.style.position = '';
          body.style.top = '';
          body.style.width = '';
          window.scrollTo(0, scrollY);

          // CSSの設定に戻す
          html.style.scrollBehavior = '';
        }
      };

      // すべてのメニューを閉じる処理
      var closeAllMenus = function closeAllMenus() {
        if (menu.classList.contains("is_open")) {
          fixed(false);
        }
        menu.classList.remove("is_open");
        if (menuOpen) menuOpen.classList.remove("is_open");
        if (header) header.classList.remove("is_open");
        if (subMenu) subMenu.classList.remove("is_open");
        if (torggleButton) torggleButton.classList.remove("is_open");
      };

      var toggleMenu = function toggleMenu(element, button) {
        var isAlreadyOpen = element.classList.contains("is_open");
        if (!isAlreadyOpen) {
          closeAllMenus();
          element.classList.add("is_open");
          button.classList.add("is_open");
          header.classList.add("is_open");
          fixed(true);
        } else {
          closeAllMenus();
        }
      };

      if (menuOpen) {
        menuOpen.addEventListener('click', function () {
          return toggleMenu(menu, menuOpen);
        });
      }
      if (bg) {
        bg.addEventListener('click', closeAllMenus);
      }

      // --------------------------------------------------
      // ★ 修正：ドロワーメニュー内のアンカーリンク例外処理
      // --------------------------------------------------
      var anchorLinks = menu.querySelectorAll('a[href*="#"]');
      anchorLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href');

          var targetId = href.includes('#') ? href.split('#')[1] : null;
          var isCurrentPageAnchor = href.startsWith('#') || (targetId && href.startsWith(window.location.pathname));

          if (isCurrentPageAnchor && targetId) {
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
              e.preventDefault();

              // 1. まずメニューを閉じて body の fixed 固定を解除
              closeAllMenus();

              // 2. レイアウトシフト（アニメーションや再描画）が終わるのを少し待つ（200ms〜300ms）
              setTimeout(function () {
                // 固定ヘッダーの実際の高さを動的に取得（PC/SP自動判定）
                var headerHeight = header ? header.offsetHeight : 0;

                // ターゲット要素の現在の絶対位置を取得
                var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

                // ヘッダーの高さ分だけを引いて正確な位置を計算
                var offsetPosition = targetPosition - headerHeight;

                // スムーススクロール実行
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }, 300); // メニューが閉じるCSS transitionの時間（約0.3秒）に合わせます

            } else {
              closeAllMenus();
            }
          } else if (isCurrentPageAnchor && href === '#') {
            e.preventDefault();
            closeAllMenus();
          } else {
            closeAllMenus();
          }
        });
      });
    }
  }, {
    key: "subMenuToggle",
    value: function subMenuToggle() {
      var button = document.querySelector(".headerMenu__item--toggle");
      var subMenu = document.querySelector(".headerMenu__box--sub");
      var backButton = document.querySelector(".headerMenu__back-item");

      var toggleSubMenu = function toggleSubMenu() {
        if (subMenu) subMenu.classList.toggle("is_open");
        if (button) button.classList.toggle("is_open");
      };

      var closeSubMenu = function closeSubMenu() {
        if (subMenu) subMenu.classList.remove("is_open");
        if (button) button.classList.remove("is_open");
      };

      if (button) button.addEventListener('click', toggleSubMenu);
      if (backButton) backButton.addEventListener('click', closeSubMenu);
    }
  }]);
}();

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var historySlide = exports["default"] = /*#__PURE__*/function () {
  function historySlide() {
    _classCallCheck(this, historySlide);
    if (!document.querySelector('.history')) return;
    this.sliderInit();
    this.toggleContents();
  }
  return _createClass(historySlide, [{
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.history__box');
      boxes.forEach(function (box) {
        var splideElement = box.querySelector('.splide');
        var historyNav = box.querySelector('.history__nav');
        var navItems = historyNav.querySelectorAll('.history__nav-item');
        var splide = new Splide(splideElement, {
          perPage: 1,
          perMove: 1,
          gap: 50,
          pagination: false,
          arrows: true,
          speed: 800
        });
        splide.on('mounted', function () {
          navItems[0].classList.add('is_active');
        });
        splide.on('move', function (newIndex) {
          navItems.forEach(function (item) {
            return item.classList.remove('is_active');
          });
          navItems[newIndex].classList.add('is_active');
        });
        navItems.forEach(function (navItem, index) {
          navItem.addEventListener('click', function () {
            splide.go(index);
          });
        });
        splide.mount();
      });
    }
  }, {
    key: "toggleContents",
    value: function toggleContents() {
      var historyBoxes = document.querySelectorAll('.history__box');
      historyBoxes.forEach(function (historyBox) {
        var historyEra = historyBox.querySelector('.history__era');
        historyEra.addEventListener('click', function () {
          var historyContents = historyBox.querySelector('.history__contents');
          var historyContentsInner = historyBox.querySelector('.history__contents-inner');
          var maxHeight = historyContentsInner ? getComputedStyle(historyContentsInner).height : '0px';
          historyBoxes.forEach(function (otherHistoryBox) {
            if (otherHistoryBox !== historyBox && otherHistoryBox.querySelector('.history__contents').style.maxHeight) {
              otherHistoryBox.querySelector('.history__contents').style.maxHeight = '';
              otherHistoryBox.querySelector('.history__era').classList.remove('is_open');
            }
          });
          if (historyContents.style.maxHeight) {
            historyContents.style.maxHeight = '';
            historyEra.classList.remove('is_open');
          } else {
            historyContents.style.maxHeight = maxHeight;
            historyEra.classList.add('is_open');
          }
        });
      });
      window.addEventListener('resize', function () {
        historyBoxes.forEach(function (historyBox) {
          var historyContents = historyBox.querySelector('.history__contents');
          var historyContentsInner = historyBox.querySelector('.history__contents-inner');
          var historyEra = historyBox.querySelector('.history__era');
          if (historyEra.classList.contains('is_open')) {
            // 開いているアコーディオンのみ処理
            var newMaxHeight = historyContentsInner ? getComputedStyle(historyContentsInner).height : '0px';
            historyContents.style.maxHeight = newMaxHeight;
          }
        });
      });
    }
  }]);
}();

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var historySlide = exports["default"] = /*#__PURE__*/function () {
  function historySlide() {
    _classCallCheck(this, historySlide);
    if (!document.querySelector('.main-wrapper--about .quality')) return;
    this.sliderInit();
  }
  return _createClass(historySlide, [{
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.quality__inner');
      boxes.forEach(function (box) {
        var splideElement = box.querySelector('.splide');
        var splide = new Splide(splideElement, {
          perPage: 1,
          perMove: 1,
          gap: 10,
          pagination: true,
          arrows: true,
          speed: 800
        });
        splide.mount();
      });
    }
  }]);
}();

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RecruitRequirement = exports["default"] = /*#__PURE__*/function () {
  function RecruitRequirement() {
    _classCallCheck(this, RecruitRequirement);
    if (!document.querySelector('.main-wrapper--recruit .requirement')) return;
    this.toggleContents();
  }
  return _createClass(RecruitRequirement, [{
    key: "toggleContents",
    value: function toggleContents() {
      var requirementSections = document.querySelectorAll('.requirement__section');
      var firstSection = requirementSections[0];
      var firstSectionContents = firstSection.querySelector('.requirement__section-contents');
      var firstSectionContentsInner = firstSection.querySelector('.requirement__section-contentsInner');
      var firstMaxHeight = firstSectionContentsInner ? getComputedStyle(firstSectionContentsInner).height : '0px';
      firstSectionContents.style.maxHeight = firstMaxHeight;
      firstSection.classList.add('is_open');
      requirementSections.forEach(function (section) {
        var sectionHeader = section.querySelector('.requirement__section-header');
        var sectionHeaderButton = section.querySelector('.requirement__section-headerButton');
        section.addEventListener('click', function (e) {
          if (section.classList.contains('is_open')) {
            return;
          }
          var sectionContents = section.querySelector('.requirement__section-contents');
          var sectionContentsInner = section.querySelector('.requirement__section-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.requirement__section-contents').style.maxHeight) {
              otherSection.querySelector('.requirement__section-contents').style.maxHeight = '';
              otherSection.querySelector('.requirement__section-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
        sectionHeaderButton.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!section.classList.contains('is_open')) {
            e.preventDefault();
          }
          var sectionContents = section.querySelector('.requirement__section-contents');
          var sectionContentsInner = section.querySelector('.requirement__section-contentsInner');
          var maxHeight = sectionContentsInner ? getComputedStyle(sectionContentsInner).height : '0px';
          requirementSections.forEach(function (otherSection) {
            if (otherSection !== section && otherSection.querySelector('.requirement__section-contents').style.maxHeight) {
              otherSection.querySelector('.requirement__section-contents').style.maxHeight = '';
              otherSection.querySelector('.requirement__section-header').parentElement.classList.remove('is_open');
            }
          });
          if (sectionContents.style.maxHeight) {
            sectionContents.style.maxHeight = '';
            sectionHeader.parentElement.classList.remove('is_open');
          } else {
            sectionContents.style.maxHeight = maxHeight;
            sectionHeader.parentElement.classList.add('is_open');
          }
        });
      });
    }
  }]);
}();

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScrollAnimation = exports["default"] = /*#__PURE__*/function () {
  function ScrollAnimation() {
    _classCallCheck(this, ScrollAnimation);
    this.scrollAnimeObserver();
    this.visibleAnimElemOnLoad();
  }
  /**
  * 領域内に入ってきた要素にクラスを付与する。
  */
  return _createClass(ScrollAnimation, [{
    key: "scrollAnimeObserver",
    value: function scrollAnimeObserver() {
      var aniBoxes = [].slice.call(document.querySelectorAll('.u-anime'));
      var options = {
        root: null,
        rootMargin: '0px 0px -15% 0px'
      };
      var aniBoxObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var cont = entry.target;
            var anim = cont.dataset.anim;
            if (!anim) {
              anim = "is_anime";
            }
            if (cont.classList.contains(anim) === false) {
              cont.classList.add(anim);
            }
            aniBoxObserver.unobserve(cont);
          }
        });
      }, options);
      aniBoxes.forEach(function (aniBox) {
        aniBoxObserver.observe(aniBox);
      });
    }

    /**
    * ページロード時に現在位置より上にある要素のアニメーションを完了させる。
    */
  }, {
    key: "visibleAnimElemOnLoad",
    value: function visibleAnimElemOnLoad() {
      var aniBoxes = [].slice.call(document.querySelectorAll('.u-anime'));
      aniBoxes.forEach(function (el) {
        var pos = el.getBoundingClientRect().top;
        var anim = el.dataset.anim;
        if (!anim) {
          anim = "is_anime";
        }
        if (pos < 0) {
          el.classList.add(anim);
        }
      });
    }
  }]);
}();

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var scrollHeader = exports["default"] = /*#__PURE__*/function () {
  function scrollHeader() {
    _classCallCheck(this, scrollHeader);
    if (!document.querySelector('.header')) return;
    this.scrollCheck();
  }
  return _createClass(scrollHeader, [{
    key: "scrollCheck",
    value: function scrollCheck() {
      var header = document.querySelector('.header');
      var headerHeight = header.offsetHeight;
      var startPos = 0;
      window.addEventListener('scroll', function () {
        var scrollPos = window.scrollY;
        if (scrollPos > startPos && scrollPos > headerHeight && scrollPos > 500) {
          header.classList.add('header--isScroll');
        } else {
          header.classList.remove('header--isScroll');
        }
        startPos = scrollPos;
      });
    }
  }]);
}();

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var shopList = exports["default"] = /*#__PURE__*/function () {
  function shopList() {
    _classCallCheck(this, shopList);
    if (!document.querySelector('.main-wrapper--shop')) return;
    this.selectRedirect();
  }
  return _createClass(shopList, [{
    key: "selectRedirect",
    value: function selectRedirect() {
      var selectBox = document.querySelector('#brand-select');
      selectBox.addEventListener('change', function (event) {
        var loc = location;
        var value = event.target.value;
        location.href = value;
      });
    }
  }]);
}();

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var topBrandsSlide = exports["default"] = /*#__PURE__*/function () {
  function topBrandsSlide() {
    var _this = this;
    _classCallCheck(this, topBrandsSlide);
    if (!document.querySelector('.main-wrapper--top .brands')) return;
    this.itemSet().then(function () {
      _this.sliderInit();
    });
  }
  return _createClass(topBrandsSlide, [{
    key: "itemSet",
    value: function () {
      var _itemSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var productLists, productHTMLPromises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              productLists = document.querySelectorAll('.brands .splide__list');
              productHTMLPromises = Array.from(productLists).map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(productList) {
                  var goodsList, url, generateProductHTML, response, jsonData;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        goodsList = productList.dataset.goods;
                        url = "https://imayo-boutique.jp/api/goodslistapi.aspx?type=json&goods=".concat(goodsList);
                        _context.prev = 2;
                        generateProductHTML = function generateProductHTML(product) {
                          var href = "/shop/g/g" + product.goods + "/";
                          var g_e_name=product.name;
                          if(jQuery('input[name="login-st"]')[0]){
                            if(product.globale_name){
                              g_e_name='<span class="block-globale-foreign--hide" data-ge-hide>'+product.name+'</span><span class="block-globale-foreign--show" data-ge-show>'+product.globale_name+'</span>';
                            }
                          }

                          return "\n            <a class=\"brands__item splide__slide\" href=\"".concat(href, "\">\n              <div class=\"brands__img\">\n                <picture>\n                  <img src=\"").concat(product.src_l, "\" alt=\"").concat(product.name, "\">\n                </picture>\n              </div>\n              <div class=\"brands__texts\">\n                <div class=\"brands__title\" data-stt-ignore>\n                  ").concat(g_e_name, "\n                </div>\n                <div class=\"brands__price\">\n                  ").concat(product.format_price, "\n                </div>\n              </div>\n            </a>\n          ");
                        };
                        _context.next = 6;
                        return fetch(url);
                      case 6:
                        response = _context.sent;
                        if (response.ok) {
                          _context.next = 9;
                          break;
                        }
                        throw new Error('Network response was not ok');
                      case 9:
                        _context.next = 11;
                        return response.json();
                      case 11:
                        jsonData = _context.sent;
                        jsonData.forEach(function (product) {
                          var productHTML = generateProductHTML(product);
                          productList.innerHTML += productHTML;
                        });
                        _context.next = 18;
                        break;
                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](2);
                        console.error('Error fetching data:', _context.t0);
                      case 18:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[2, 15]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context2.next = 4;
              return Promise.all(productHTMLPromises);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function itemSet() {
        return _itemSet.apply(this, arguments);
      }
      return itemSet;
    }()
  }, {
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.main-wrapper--top .brands .splide');
      boxes.forEach(function (box) {
        var splide = new Splide(box, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: 0,
          pagination: true,
          arrows: false,
          speed: 1000
        });
        splide.mount();
      });
    }
  }]);
}();

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var topHeader = exports["default"] = /*#__PURE__*/function () {
  function topHeader() {
    _classCallCheck(this, topHeader);
    if (!document.querySelector('.main-wrapper--top')) return;
    this.mvCheck();
  }
  return _createClass(topHeader, [{
    key: "mvCheck",
    value: function mvCheck() {
      var header = document.querySelector('.header');
      var target = document.querySelector('.main-wrapper--top .mv');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            header.classList.add('header--mvHide');
          } else {
            header.classList.remove('header--mvHide');
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0
      });
      observer.observe(target);
    }
  }]);
}();

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var topMvSlide = exports["default"] = /*#__PURE__*/function () {
  function topMvSlide() {
    _classCallCheck(this, topMvSlide);
    if (!document.querySelector('.main-wrapper--top .mv')) return;
    this.sliderInit();
  }
  return _createClass(topMvSlide, [{
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.main-wrapper--top .mv .splide');
      boxes.forEach(function (box) {
        var splide = new Splide(box, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: 0,
          pagination: true,
          arrows: false,
          speed: 1000,
          autoplay: false,
          interval: 4000,
          pauseOnHover: false,
          pauseOnFocus: false
        });
        splide.on('ready', function() {
          // const animationDuration = 7000
          const animationDuration = 10700
          const loadingAnimationStatus = sessionStorage.getItem('loadingAnimation')
          if(loadingAnimationStatus) {
            // 自動再生開始
            splide.Components.Autoplay.play();
          } else {
            // アニメーションが終わってから自動再生開始
            setTimeout(function() {
              splide.Components.Autoplay.play();
            }, animationDuration)
          }
        })
        splide.mount();
      });
    }
  }]);
}();

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var topProductsSlide = exports["default"] = /*#__PURE__*/function () {
  function topProductsSlide() {
    var _this = this;
    _classCallCheck(this, topProductsSlide);
    if (!document.querySelector('.main-wrapper--top .products')) return;
    this.itemSet().then(function () {
      // itemSet が完了したら sliderInit を実行
      _this.sliderInit();
    });
  }
  return _createClass(topProductsSlide, [{
    key: "itemSet",
    value: function () {
      var _itemSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var productLists, productHTMLPromises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              productLists = document.querySelectorAll('.products .splide__list');
              productHTMLPromises = Array.from(productLists).map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(productList) {
                  var goodsList, url, generateProductHTML, response, jsonData;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        goodsList = productList.dataset.goods;
                        url = "https://imayo-boutique.jp/api/goodslistapi.aspx?type=json&goods=".concat(goodsList);
                        _context.prev = 2;
                        generateProductHTML = function generateProductHTML(product) {
                          var href = "/shop/g/g" + product.goods + "/";
                          var g_e_name=product.name;
                          if(jQuery('input[name="login-st"]')[0]){
                            if(product.globale_name){
                              g_e_name='<span class="block-globale-foreign--hide" data-ge-hide>'+product.name+'</span><span class="block-globale-foreign--show" data-ge-show>'+product.globale_name+'</span>';
                            }
                          }
                          return "\n            <a class=\"products__item splide__slide\" href=\"".concat(href, "\">\n              <div class=\"products__img\">\n                <picture>\n                  <img src=\"").concat(product.src_l, "\" alt=\"").concat(product.name, "\">\n                </picture>\n              </div>\n              <div class=\"products__texts\">\n                <div class=\"products__title\" data-stt-ignore>\n                  ").concat(g_e_name, "\n                </div>\n                <div class=\"products__price\">\n                  ").concat(product.format_price, "\n                </div>\n              </div>\n            </a>\n          ");
                        };
                        _context.next = 6;
                        return fetch(url);
                      case 6:
                        response = _context.sent;
                        if (response.ok) {
                          _context.next = 9;
                          break;
                        }
                        throw new Error('Network response was not ok');
                      case 9:
                        _context.next = 11;
                        return response.json();
                      case 11:
                        jsonData = _context.sent;
                        jsonData.forEach(function (product) {

                          var productHTML = generateProductHTML(product);
                          productList.innerHTML += productHTML;
                        });
                        _context.next = 18;
                        break;
                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](2);
                        console.error('Error fetching data:', _context.t0);
                      case 18:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[2, 15]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context2.next = 4;
              return Promise.all(productHTMLPromises);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function itemSet() {
        return _itemSet.apply(this, arguments);
      }
      return itemSet;
    }()
  }, {
    key: "sliderInit",
    value: function sliderInit() {
      var boxes = document.querySelectorAll('.main-wrapper--top .products .splide');
      boxes.forEach(function (box) {
        var splide = new Splide(box, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: 0,
          pagination: true,
          arrows: false,
          speed: 1000,
          mediaQuery: 'min',
          breakpoints: {
            768: {
              perPage: 3,
              perMove: 3,
              pagination: false,
              drag: false
            }
          }
        });
        splide.mount();
      });
    }
  }]);
}();

},{}]},{},[1]);
